import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import ResendVerification from '../components/ResendVerification';
import styles from './LoginPage.module.css';
import { useTranslation } from 'react-i18next';

const EmailVerificationNotice = () => {
  const location = useLocation();
  const resendVerificationToken = location.state?.resendVerificationToken || '';
  const email = location.state?.email || '';
  const { t } = useTranslation('auth');

  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{t('emailVerificationNotice.title')}</h2>
      <p>{t('emailVerificationNotice.thanks')}</p>

      <p>
        {t('emailVerificationNotice.body')}
      </p>

      {email && <p>{t('emailVerificationNotice.sentTo')} {email}</p>}

      <ResendVerification token={resendVerificationToken} />

      {!resendVerificationToken && (
        <p>
          {t('emailVerificationNotice.resendHint')}<Link to="/login">{t('emailVerificationNotice.resendHintLink')}</Link>{t('emailVerificationNotice.resendHintSuffix')}
        </p>
      )}
    </div>
  );
};

export default EmailVerificationNotice;
